import logo from './logo.svg';
import './App.css';
import AppRoutes from './Routes/AppRouter';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
